// @flow
import React, { Component, Fragment } from "react";
import classNames from "classnames";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";

import type { ErrorsType } from "../../types/UserFormType";
import {
  ErrosDisplay,
  setErrorMsg,
  checkEmail,
  checkPhone
} from "../../containers/ErrosDisplay";
import { withStyles } from "@material-ui/core/styles";
import {
  StyledSelect,
  CancelButton,
  SubmitButton,
  SingleSwitch,
  ButtonSelect
} from "imagus-components";
import CompanyBasicFields from "../companies/CompanyBasicFields";
import ProjectBasicFields from "./ProjectBasicFields";
import { CompanyTypes } from "../../../global/types/CompanyTypes";
import { buildCompanyInfoJson } from "../../components/companies/CompileCompanytoJson";
import { GraphqlLineBreak, utf8OutRangeFilter } from "../../../global/functions/MultilLineStrings";
import CompanyInfo from "../../components/companies/CompanyInfo";

const styles = (theme: *): * => ({
  tabs: {
    position: "fixed",
    zIndex: 1000,
    marginTop: "-30px",
    backgroundColor: "white",
    paddingTop: theme.spacing.unit * 1,
    paddingBottom: theme.spacing.unit * 2,
    width: "524px",
    textAlign: "center"
  },
  form: {
    paddingTop: theme.spacing.unit * 2
  },
  paper: {
    paddingTop: theme.spacing.unit * 1,
    paddingBottom: theme.spacing.unit * 1,
    paddingLeft: theme.spacing.unit * 1,
    paddingRight: theme.spacing.unit * 1,
    marginTop: theme.spacing.unit * 2
  },
  hidden: {
    display: "none"
  },
  bottom: {
    marginTop: theme.spacing.unit * 3,
    display: "flow-root"
  },
  leftButton: {
    float: "left"
  },
  rightButton: {
    float: "right"
  }
});

type CreateProjectFormPropsType = {
  onClose: Function,
  DistributerList: Array<*>,
  ResellerCompanyList: Array<*>,
  updateEndUserList: Function,
  createProject: Function,
  createCompany: Function,
  initialForm: { [key: string]: * },
  forReseller: boolean,
  classes: { [key: string]: * }
};

type CompanyInfoStatesType = {
  company_name: string,
  abn: string,
  address: string,
  suburb: string,
  postcode: string,
  city: string,
  state: string,
  other_state: string,
  country: string,
  contact_name: string,
  contact_email: string,
  contact_number: string,
  notes: string,
  company_type: string,
  authorised_reseller: boolean
};

type ProjectInfoStatesType = {
  project_name: string,
  expiry_date: Date | null,
  face_count: string,
  camera_count: string,
  address: string,
  suburb: string,
  postcode: string,
  city: string,
  state: string,
  other_state: string,
  country: string,
  notes: string
};

type CreateProjectFormStateType = {
  errors: ErrorsType,
  loading: boolean,
  formIndex: number,
  distributerId: string,
  isNewReseller: boolean,
  isNewEndUser: boolean,
  resellerId: string,
  reseller: { [key: string]: string } | null,
  endUserList: Array<*> | null,
  endUserId: string,
  endUser: { [key: string]: string } | null,
  resellerForm: CompanyInfoStatesType,
  enduserForm: CompanyInfoStatesType,
  projectForm: ProjectInfoStatesType
};

const DEBOUNCETIME = 500;

const initialform: CreateProjectFormStateType = {
  errors: {},
  loading: false,
  formIndex: 1,
  distributerId: "",
  isNewReseller: false,
  isNewEndUser: false,
  resellerId: "",
  reseller: null,
  endUserList: null,
  endUserId: "",
  endUser: null,
  resellerForm: {
    company_name: "",
    abn: "",
    address: "",
    suburb: "",
    postcode: "",
    city: "",
    state: "",
    other_state: "",
    country: "Australia",
    contact_name: "",
    contact_email: "",
    contact_number: "",
    notes: "",
    company_type: "RESELLER",
    authorised_reseller: false
  },
  enduserForm: {
    company_name: "",
    abn: "",
    address: "",
    suburb: "",
    postcode: "",
    city: "",
    state: "",
    other_state: "",
    country: "Australia",
    contact_name: "",
    contact_email: "",
    contact_number: "",
    notes: "",
    company_type: "ENDUSER",
    authorised_reseller: false
  },
  projectForm: {
    project_name: "",
    expiry_date: null,
    face_count: "",
    camera_count: "",
    address: "",
    suburb: "",
    postcode: "",
    city: "",
    state: "",
    other_state: "",
    country: "Australia",
    notes: ""
  }
};

class CreateProjectForm extends Component<
  CreateProjectFormPropsType,
  CreateProjectFormStateType
> {
  timeout: *;
  constructor(props: CreateProjectFormPropsType) {
    super(props);
    this.state = initialform;
    this.submit = this.submit.bind(this);
  }

  componentDidMount() {
    this.setState({ ...initialform, ...this.props.initialForm, errors: {} });
  }

  handlePageSwitch = (name: string, value: number): * => {
    this.setState({ [name]: value });
  };

  handleSwitch = (e: SyntheticInputEvent<*>): * => {
    const name = e.target.name;
    this.setState(
      {
        [name]: !this.state[name]
      },
      (): * => {
        if (name === "isNewReseller") {
          this.setState({ isNewEndUser: true });
          if (this.state.isNewReseller) {
            this.setState({
              errors: setErrorMsg(this.state.errors, "reseller", "", true)
            });
          }
        }
        if (name === "isNewEndUser") {
          if (this.state.isNewEndUser) {
            this.setState({
              errors: setErrorMsg(this.state.errors, "enduser", "", true)
            });
          }
        }
      }
    );
  };

  handleSelectChange = (formName?: string): * => (
    e: SyntheticInputEvent<*>
  ): * => {
    const name = e.target.name;
    const value = e.target.value;
    let formValues;

    if (formName) {
      formValues = { ...this.state[formName] };
      formValues[name] = value;
    } else {
      formName = name;
      formValues = value;
    }

    this.setState(
      { [formName]: formValues },
      (): * => {
        if (name === "resellerId") {
          this.checkCompanySelect("reseller");

          const values = this.props.updateEndUserList(value);
          this.setState({
            reseller: values[0],
            endUserList: values[1],
            endUserId: "",
            endUser: null
          });
        }
        if (name === "endUserId") {
          this.checkCompanySelect("enduser");

          const children = this.state.reseller.children.edges;
          let index = children.findIndex(x => x.node.id === value);
          this.setState({ endUser: children[index].node });
        }
        if (name === "distributerId") {
          this.checkCompanyForm("resellerForm");
        }
      }
    );
  };

  handleTextChange = (formName: string): * => (
    e: Event & { currentTarget: HTMLInputElement }
  ): * => {
    const name = e.currentTarget.name;
    const value = e.currentTarget.value;

    let formValues = { ...this.state[formName] };
    formValues[name] = value;

    this.setState(
      { [formName]: formValues },
      (): * => {
        if (formName === "projectForm") {
          this.checkProjectForm();
        } else {
          this.checkCompanyForm(formName);
        }

        if (name === "contact_email") {
          clearTimeout(this.timeout);
          this.timeout = setTimeout(
            function(val: string): * {
              this.setState({
                errors: checkEmail(
                  this.state.errors,
                  val,
                  formName === "resellerForm" ? "email" : "username"
                )
              });
            }.bind(this, value),
            DEBOUNCETIME
          );
        }

        if (name === "contact_number") {
          clearTimeout(this.timeout);
          this.timeout = setTimeout(
            function(val: string) {
              this.setState({
                errors: checkPhone(
                  this.state.errors,
                  val,
                  formName === "resellerForm" ? "phone" : "password"
                )
              });
            }.bind(this, value),
            DEBOUNCETIME
          );
        }
      }
    );
  };

  handleCheckBoxChange = (formName: string): * => (
    e: Event & { currentTarget: HTMLInputElement }
  ): * => {
    const name = e.currentTarget.name;

    let formValues = { ...this.state[formName] };
    formValues[name] = !formValues[name];
    this.setState({
      [formName]: formValues
    });
  };

  syncDateChange = (formName: string): * => (name: string, date: Date): * => {
    let formValues = { ...this.state[formName] };
    formValues[name] = date;
    this.setState(
      { [formName]: formValues },
      (): * => {
        if (formName === "projectForm") {
          this.checkProjectForm();
        }
      }
    );
  };

  checkCompanySelect = (type: "reseller" | "enduser"): * => {
    const name = type === "reseller" ? "resellerId" : "endUserId";
    if (this.state[name] === "") {
      this.setState({
        errors: setErrorMsg(
          this.state.errors,
          type,
          "Please Select a " + type + " company."
        )
      });
      return false;
    } else {
      this.setState({ errors: setErrorMsg(this.state.errors, type, "", true) });
      return true;
    }
  };

  checkCompanyForm = (formName: string, lastCheck?: boolean = false): * => {
    const states = this.state[formName];
    const errorField = formName === "resellerForm" ? "user" : "facebase";
    const errorMsg =
      formName === "resellerForm" ? "reseller company" : "end user company";
    const distributerCheck =
      formName === "resellerForm" ? this.state.distributerId === "" : false;

    if (
      states.company_name.trim() === "" ||
      states.contact_name.trim() === "" ||
      states.contact_number.trim() === "" ||
      states.contact_email.trim() === "" ||
      distributerCheck
    ) {
      if (lastCheck) {
        this.setState({
          errors: setErrorMsg(
            this.state.errors,
            errorField,
            "Please fill in the required fields for the " + errorMsg + "."
          )
        });
      }
      return false;
    } else {
      this.setState({
        errors: setErrorMsg(this.state.errors, errorField, "", true)
      });
      return true;
    }
  };

  checkProjectForm = (lastCheck?: boolean = false): * => {
    const states = this.state.projectForm;
    if (states.project_name.trim() === "" || states.expiry_date === null) {
      if (lastCheck) {
        this.setState({
          errors: setErrorMsg(
            this.state.errors,
            "project",
            "Please fill in the required fields for the project detail."
          )
        });
      }
      return false;
    } else {
      this.setState({
        errors: setErrorMsg(this.state.errors, "project", "", true)
      });
      return true;
    }
  };

  checkFormValidation = (): * => {
    let resellerSuccess;
    if (this.state.isNewReseller) {
      resellerSuccess = this.checkCompanyForm("resellerForm", true);
    } else {
      resellerSuccess = this.checkCompanySelect("reseller");
    }

    let enduserSuccess;
    if (this.state.isNewEndUser) {
      enduserSuccess = this.checkCompanyForm("enduserForm", true);
    } else {
      enduserSuccess = this.checkCompanySelect("enduser");
    }

    let projectSuccess = this.checkProjectForm(true);

    if (resellerSuccess && enduserSuccess && projectSuccess) {
      return true;
    } else {
      if (!resellerSuccess) {
        this.setState({ formIndex: 1 });
      } else if (!enduserSuccess) {
        this.setState({ formIndex: 2 });
      } else {
        this.setState({ formIndex: 3 });
      }
      return false;
    }
  };

  submit = async (e: Event): * => {
    const success = this.checkFormValidation();
    if (success) {
      this.setState((): * => ({ loading: true }));

      const createCompanyCall = (
        company: CompanyInfoStatesType,
        parentId: string,
        doneCall: Function,
        failCall: Function
      ): Function => {
        this.props.createCompany(
          company.contact_number.trim(),
          company.company_name,
          GraphqlLineBreak(utf8OutRangeFilter(company.notes)),
          company.abn,
          parentId,
          company.contact_email,
          company.postcode,
          company.contact_name,
          company.city,
          company.country,
          company.state === "Other" ? company.other_state : company.state,
          company.suburb,
          company.address,
          doneCall,
          failCall,
          company.authorised_reseller,
          company.company_type
        );
      };

      const createProjectCall = (
        project: ProjectInfoStatesType,
        resellerId: string,
        enduserId: string,
        shouldUpdateResellerTree: boolean,
        doneCallback: Function,
        failCallBack: Function
      ): Function => {
        this.props.createProject(
          project.project_name,
          project.expiry_date,
          GraphqlLineBreak(utf8OutRangeFilter(project.notes)),
          project.camera_count,
          project.face_count,
          project.address,
          project.suburb,
          project.city,
          project.state === "Other" ? project.other_state : project.state,
          project.country,
          project.postcode,
          resellerId,
          enduserId,
          shouldUpdateResellerTree,
          doneCallback,
          failCallBack
        );
      };

      if (this.state.isNewReseller) {
        // new reseller must have new end user
        createCompanyCall(
          this.state.resellerForm,
          this.state.distributerId,
          (reseller: *): * => {
            createCompanyCall(
              this.state.enduserForm,
              reseller.id,
              (enduser: *): * => {
                createProjectCall(
                  this.state.projectForm,
                  reseller.id,
                  enduser.id,
                  true,
                  this.submitDone,
                  this.submitFail
                );
              },
              this.submitFail
            );
          },
          this.submitFail
        );
      } else {
        if (this.state.isNewEndUser) {
          createCompanyCall(
            this.state.enduserForm,
            this.state.resellerId,
            (enduser: *): * => {
              createProjectCall(
                this.state.projectForm,
                this.state.resellerId,
                enduser.id,
                true,
                this.submitDone,
                this.submitFail
              );
            },
            this.submitFail
          );
        } else {
          createProjectCall(
            this.state.projectForm,
            this.state.resellerId,
            this.state.endUserId,
            false,
            this.submitDone,
            this.submitFail
          );
        }
      }
    }
  };

  submitDone = () => {
    this.props.onClose();
  };

  submitFail = (errors: ErrorsType) => {
    this.setState({ errors: errors, loading: false });
  };

  render(): React$Element<*> {
    const classes = this.props.classes;
    const errors = this.state.errors;
    const loading = this.state.loading;

    const ResellerTypes = CompanyTypes.filter(
      (row: *): * => row.value === "RESELLER"
    );
    const EnduserTypes = CompanyTypes.filter(
      (row: *): * => row.value === "ENDUSER"
    );

    return (
      <div className="app-wrapper">
        <div className="app-panel">
          <div className={classes.tabs}>
            <ButtonSelect
              value={this.state.formIndex}
              name="formIndex"
              buttons={[
                { label: "Reseller Company", value: 1 },
                { label: "End User Company", value: 2 },
                { label: "Project Detail", value: 3 }
              ]}
              handleChange={this.handlePageSwitch}
              noIndicator
            />
          </div>
          <div className="app-panel-content">
            <Grid container spacing={0} className={classes.form}>
              <Grid item xs={12}>
                <Paper
                  className={classNames(classes.paper, {
                    [classes.hidden]: this.state.formIndex !== 1
                  })}
                >
                  <Grid container spacing={8}>
                    {!this.state.isNewReseller && (
                      <Fragment>
                        <Grid item xs={12}>
                          <StyledSelect
                            value={this.state.resellerId}
                            onChange={this.handleSelectChange()}
                            name="resellerId"
                            label="Select from Existing Resellers"
                            isRequired={true}
                            menus={this.props.ResellerCompanyList}
                            isStyled
                            isInvalid={errors.reseller !== undefined}
                          />
                        </Grid>
                        {this.state.reseller && (
                          <Grid item xs={12}>
                            <Paper style={{ paddingTop: "5px" }}>
                              <Typography variant="h5" className="form-text">
                                Reseller Company
                              </Typography>
                              <CompanyInfo
                                company={buildCompanyInfoJson(
                                  this.state.reseller
                                )}
                              />
                            </Paper>
                          </Grid>
                        )}
                      </Fragment>
                    )}
                    {!this.props.forReseller && (
                      <Grid item xs={12}>
                        <SingleSwitch
                          value={this.state.isNewReseller}
                          name="isNewReseller"
                          isRequired={false}
                          label="Create New Reseller"
                          handleChange={this.handleSwitch}
                        />
                      </Grid>
                    )}
                    {this.state.isNewReseller && (
                      <Fragment>
                        {this.props.DistributerList.length > 0 && (
                          <StyledSelect
                            value={this.state.distributerId}
                            onChange={this.handleSelectChange()}
                            name="distributerId"
                            label="Select the parent company for this reseller"
                            isRequired={true}
                            menus={this.props.DistributerList}
                            isStyled
                            isInvalid={errors.billing !== undefined}
                          />
                        )}
                        <CompanyBasicFields
                          company_name={this.state.resellerForm.company_name}
                          abn={this.state.resellerForm.abn}
                          address={this.state.resellerForm.address}
                          suburb={this.state.resellerForm.suburb}
                          postcode={this.state.resellerForm.postcode}
                          city={this.state.resellerForm.city}
                          state={this.state.resellerForm.state}
                          other_state={this.state.resellerForm.other_state}
                          country={this.state.resellerForm.country}
                          contact_name={this.state.resellerForm.contact_name}
                          contact_email={this.state.resellerForm.contact_email}
                          contact_number={
                            this.state.resellerForm.contact_number
                          }
                          notes={this.state.resellerForm.notes}
                          company_type={this.state.resellerForm.company_type}
                          authorised_reseller={
                            this.state.resellerForm.authorised_reseller
                          }
                          handleTextChange={this.handleTextChange(
                            "resellerForm"
                          )}
                          handleSelectChange={this.handleSelectChange(
                            "resellerForm"
                          )}
                          handleCheckBoxChange={this.handleCheckBoxChange(
                            "resellerForm"
                          )}
                          emailInvalid={
                            errors.email === undefined ? false : true
                          }
                          phoneInvalid={
                            errors.phone === undefined ? false : true
                          }
                          companyInvalid={false}
                          hasCompanyType={true}
                          companyTypes={ResellerTypes}
                        />
                      </Fragment>
                    )}
                  </Grid>
                </Paper>
              </Grid>
              <Grid item xs={12}>
                <Paper
                  className={classNames(classes.paper, {
                    [classes.hidden]: this.state.formIndex !== 2
                  })}
                >
                  <Grid container spacing={8}>
                    {!this.state.isNewEndUser && (
                      <Fragment>
                        <Grid item xs={12}>
                          <StyledSelect
                            value={this.state.endUserId}
                            onChange={this.handleSelectChange()}
                            name="endUserId"
                            label="Select from Existing End Users"
                            isRequired={true}
                            menus={this.state.endUserList}
                            isStyled
                            isInvalid={errors.enduser !== undefined}
                          />
                        </Grid>
                        {this.state.endUser && (
                          <Grid item xs={12}>
                            <Paper style={{ paddingTop: "5px" }}>
                              <Typography variant="h5" className="form-text">
                                End User Company
                              </Typography>
                              <CompanyInfo
                                company={buildCompanyInfoJson(
                                  this.state.endUser
                                )}
                              />
                            </Paper>
                          </Grid>
                        )}
                      </Fragment>
                    )}
                    <Grid item xs={12}>
                      <SingleSwitch
                        value={this.state.isNewEndUser}
                        name="isNewEndUser"
                        isRequired={false}
                        label="Create New End User"
                        handleChange={this.handleSwitch}
                      />
                    </Grid>
                    {this.state.isNewEndUser && (
                      <CompanyBasicFields
                        company_name={this.state.enduserForm.company_name}
                        abn={this.state.enduserForm.abn}
                        address={this.state.enduserForm.address}
                        suburb={this.state.enduserForm.suburb}
                        postcode={this.state.enduserForm.postcode}
                        city={this.state.enduserForm.city}
                        state={this.state.enduserForm.state}
                        other_state={this.state.enduserForm.other_state}
                        country={this.state.enduserForm.country}
                        contact_name={this.state.enduserForm.contact_name}
                        contact_email={this.state.enduserForm.contact_email}
                        contact_number={this.state.enduserForm.contact_number}
                        notes={this.state.enduserForm.notes}
                        company_type={this.state.enduserForm.company_type}
                        authorised_reseller={
                          this.state.enduserForm.authorised_reseller
                        }
                        handleTextChange={this.handleTextChange("enduserForm")}
                        handleSelectChange={this.handleSelectChange(
                          "enduserForm"
                        )}
                        handleCheckBoxChange={this.handleCheckBoxChange(
                          "enduserForm"
                        )}
                        emailInvalid={
                          errors.username === undefined ? false : true
                        }
                        phoneInvalid={
                          errors.password === undefined ? false : true
                        }
                        companyInvalid={false}
                        hasCompanyType={true}
                        companyTypes={EnduserTypes}
                      />
                    )}
                  </Grid>
                </Paper>
              </Grid>
              <Grid item xs={12}>
                <Paper
                  className={classNames(classes.paper, {
                    [classes.hidden]: this.state.formIndex !== 3
                  })}
                >
                  <Grid container spacing={8}>
                    <ProjectBasicFields
                      project_name={this.state.projectForm.project_name}
                      expiry_date={this.state.projectForm.expiry_date}
                      face_count={this.state.projectForm.face_count}
                      camera_count={this.state.projectForm.camera_count}
                      address={this.state.projectForm.address}
                      suburb={this.state.projectForm.suburb}
                      postcode={this.state.projectForm.postcode}
                      city={this.state.projectForm.city}
                      state={this.state.projectForm.state}
                      other_state={this.state.projectForm.other_state}
                      country={this.state.projectForm.country}
                      notes={this.state.projectForm.notes}
                      handleTextChange={this.handleTextChange("projectForm")}
                      handleSelectChange={this.handleSelectChange(
                        "projectForm"
                      )}
                      syncDateChange={this.syncDateChange("projectForm")}
                    />
                    <div className={classes.bottom} />
                  </Grid>
                </Paper>
              </Grid>
              <Grid item xs={12}>
                <ErrosDisplay errors={errors} form="create project" />
              </Grid>
              <Grid item xs={12}>
                <div className={classes.bottom}>
                  <span className={classes.leftButton}>
                    {this.state.formIndex !== 1 && (
                      <CancelButton
                        noMargin
                        title="Previous"
                        onClick={(): * =>
                          this.handlePageSwitch(
                            "formIndex",
                            this.state.formIndex === 2 ? 1 : 2
                          )
                        }
                      />
                    )}
                  </span>
                  <span className={classes.rightButton}>
                    <SubmitButton
                      {...(this.state.formIndex === 3
                        ? { loading: loading }
                        : {})}
                      {...(this.state.formIndex === 3
                        ? {
                            disabled: loading || Object.keys(errors).length > 0
                          }
                        : {})}
                      onClick={
                        this.state.formIndex === 3
                          ? this.submit
                          : (): * =>
                              this.handlePageSwitch(
                                "formIndex",
                                this.state.formIndex === 1 ? 2 : 3
                              )
                      }
                      {...(this.state.formIndex !== 3 ? { title: "Next" } : {})}
                    />
                  </span>
                </div>
              </Grid>
            </Grid>
          </div>
        </div>
      </div>
    );
  }
}

export default withStyles(styles)(CreateProjectForm);
